// Frontend API caller for /api/auth — wallet authentication + handle lookup

import type { Result } from '@shared/types/result.ts';
import { ok, err } from '@shared/types/result.ts';
import type { ChainFamily } from '@shared/types/network.ts';
import type { WalletLookupResult } from '@shared/types/wallet.ts';

export type AuthConnectResponse = Readonly<{
  readonly sessionId: string;
  readonly lookup: WalletLookupResult;
}>;

export const connectAuth = async (
  walletAddress: string,
  chainFamily: ChainFamily,
): Promise<Result<AuthConnectResponse>> => {
  try {
    const response = await fetch('/api/auth/connect', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ walletAddress, chainFamily }),
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({ error: response.statusText }));
      return err(body.error ?? 'Auth connection failed');
    }

    const json = await response.json();
    return ok(json.data as AuthConnectResponse);
  } catch (e) {
    return err(e instanceof Error ? e.message : 'Network error');
  }
};
